import { ColumnDef } from "@tanstack/react-table";
import AdvanceTable from "components/base/AdvanceTable";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import LinkProduto from "components/common/LinkProduto";

// Interface para os produtos da busca
export interface ProdutoBusca {
  id: number;
  codigo: number;
  descricao: string;
  precoCompra: number | null;
  estoque: number;
  codigosDeBarras: string[];
}

// Props do componente
interface ProdutosBuscaTableProps {
  onAdicionarProduto: (produto: ProdutoBusca) => void;
}

export const createProdutosBuscaTableColumns = (
  props: ProdutosBuscaTableProps
): ColumnDef<ProdutoBusca>[] => [
  {
    accessorKey: "codigo",
    header: "Código",
    cell: ({ getValue }) => {
      const codigo = getValue() as number;
      return (
        <span className="text-body-emphasis fw-medium">{codigo}</span>
      );
    },
    meta: {
      headerProps: { style: { width: "10%" }, className: "ps-4" },
      cellProps: {
        className: "ps-4",
      },
    },
  },
  {
    accessorKey: "descricao",
    header: "Descrição",
    cell: ({ getValue, row }) => {
      const descricao = getValue() as string;
      return (
        <LinkProduto produtoId={row.original.id}>
          <span className="text-body-emphasis fw-medium">{descricao}</span>
        </LinkProduto>
      );
    },
    meta: {
      headerProps: { style: { width: "30%" } },
      cellProps: {
        className: "fs-9",
      },
    },
  },
  {
    accessorKey: "codigosDeBarras",
    header: "Códigos de Barras",
    cell: ({ getValue }) => {
      const codigos = getValue() as string[];
      return (
        <div className="d-flex flex-wrap gap-1">
          {codigos.length > 0 ? (
            codigos.map((codigo, index) => (
              <span
                key={index}
                className="badge bg-secondary-subtle text-secondary-emphasis"
              >
                {codigo}
              </span>
            ))
          ) : (
            <span className="text-body-tertiary small">-</span>
          )}
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: "25%" } },
      cellProps: {
        className: "fs-9",
      },
    },
  },
  {
    accessorKey: "precoCompra",
    header: "Preço de Compra",
    cell: ({ getValue }) => {
      const precoCompra = getValue() as number | null;
      return (
        <span className="text-body-secondary">
          {precoCompra
            ? new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(precoCompra)
            : "R$ 0,00"}
        </span>
      );
    },
    meta: {
      headerProps: { style: { width: "15%" } },
      cellProps: {
        className: "text-center",
      },
    },
  },
  {
    accessorKey: "estoque",
    header: "Estoque",
    cell: ({ getValue }) => {
      const estoque = getValue() as number;
      return (
        <span
          className={`badge ${
            estoque > 0
              ? "bg-success-subtle text-success-emphasis"
              : "bg-danger-subtle text-danger-emphasis"
          }`}
        >
          {estoque}
        </span>
      );
    },
    meta: {
      headerProps: { style: { width: "10%" } },
      cellProps: {
        className: "text-center",
      },
    },
  },
  {
    accessorKey: "acoes",
    header: "Ações",
    cell: ({ row }) => {
      return (
        <Button
          variant="outline-primary"
          size="sm"
          className="px-3"
          onClick={() => props.onAdicionarProduto(row.original)}
          title="Adicionar ao pedido"
        >
          <FontAwesomeIcon icon={faPlus} className="me-1" />
          Adicionar
        </Button>
      );
    },
    meta: {
      headerProps: { style: { width: "10%" } },
      cellProps: {
        className: "text-center pe-4",
      },
    },
  },
];

const ProdutosBuscaTable = () => {
  return (
    <div>
      <AdvanceTable tableProps={{ className: "phoenix-table fs-9" }} />
    </div>
  );
};

export default ProdutosBuscaTable;
